export default class ExtraForm {
  constructor(data = {}) {
    this.name = data.name || null
    this.description = data.description || null
    this.price = data.price || null
    this.priceUnit = data.priceUnit || null
  }

  static validator() {
    return {
      name: 'required|min:3|max:255',
      description: 'required|min:3',
      price: 'required|numeric|min:1',
      // priceUnit: 'required',
      // images: 'required',
    }
  }
}
